import type { Map } from "maplibre-gl";

/**
 * Handle for the end-to-end tests (`web/tests/e2e`): the scenarios centre the map on a known street and
 * project coordinates to pixels before clicking, which the DOM alone does not allow. Harmless in production.
 */
export function exposeMapForTests(map: Map): void {
  (window as unknown as { __secoursnav?: { map: Map } }).__secoursnav = { map };
}
